import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  country: [],
  state: [],
  district: [],
  document: [],
  expertise: []
};

export const authSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {
    setCountry: (state, action) => {
      state.country = action.payload;
    }
  }
});

export const { setCountry } = authSlice.actions;

export default authSlice.reducer;
